module.exports = __webpack_public_path__ + "img/america.92c5f47a.png";